import { render, staticRenderFns } from "./RsaPazientePlanningPage.vue?vue&type=template&id=32ba14e4"
import script from "./RsaPazientePlanningPage.vue?vue&type=script&lang=js"
export * from "./RsaPazientePlanningPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports